import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'

export const useStyles = makeStyles()(() => ({
  metrics: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  metric: {
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '17px',
    color: C.mutedText,
    '& b': { fontWeight: 500, color: C.strongText },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 24,
    rowGap: 16,
    width: '100%',
  },
  divider: {
    gridColumn: '1 / -1',
    height: 1,
    backgroundColor: C.divider,
  },
  settingsButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    '& svg': { fontSize: 14, color: C.mutedText },
  },
}))
